import React from 'react';

/**
 * Loading Spinner Component
 * Displays an animated loading indicator
 */
const LoadingSpinner = ({ 
  size = 'md', 
  text = 'Loading...', 
  className = '',
  fullScreen = false 
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4 border-2',
    md: 'h-8 w-8 border-2',
    lg: 'h-12 w-12 border-3',
    xl: 'h-16 w-16 border-4'
  };

  const textSizes = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base',
    xl: 'text-lg'
  };

  const spinner = (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div 
        className={`
          ${sizeClasses[size]} 
          border-blue-200 
          border-t-blue-600 
          rounded-full 
          animate-spin
        `}
      />
      {text && (
        <p className={`mt-2 text-gray-600 ${textSizes[size]}`}>
          {text}
        </p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-80 z-50">
        {spinner}
      </div>
    );
  }

  return spinner;
};

/**
 * Page Loading Component
 * Full page loading state for route transitions
 */
export const PageLoading = ({ text = 'Loading...' }) => (
  <div className="flex items-center justify-center min-h-[400px]">
    <LoadingSpinner size="lg" text={text} />
  </div>
);

/**
 * Button Loading Spinner
 * Small spinner for use inside buttons
 */
export const ButtonSpinner = () => (
  <div className="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
);

/**
 * Inline Loading Component
 * For loading states within content
 */
export const InlineLoading = ({ text = 'Loading...' }) => (
  <div className="flex items-center space-x-2 text-gray-500">
    <div className="h-4 w-4 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin" />
    <span className="text-sm">{text}</span>
  </div>
);

export default LoadingSpinner;

